export enum ChargeType {
    Value = 1,
    Percentage = 2,
}
